import axios from "../../config/axiosConfig";
import { CREATE_DEBIT_NOTE, GET_DEBIT_NOTES, DEBIT_NOTE_REQUEST, UPDATE_DEBIT_NOTE, DELETE_DEBIT_NOTE,
  DEBIT_NOTE_REQUEST_FAILURE, DEBIT_NOTE_REQUEST_SUCCESS, GET_DEBIT_NOTES_PAGE} from "../types";

export const getDebitNotesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Credit_Account_Id,Item_Id'
      };
      return axios.get("/debit-note/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_NOTES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDebitNotes = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/debit-note/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_NOTES, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDebitNotesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/debit-note/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDebitNoteById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
    
      return axios.get(`/debit-note/get/${id}`).then((response) => {
        dispatch({ type: DEBIT_NOTE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createDebitNote = (debitNote) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DEBIT_NOTE_REQUEST });
      const newDebitNote = {
        ...debitNote
      };
      return axios.post("/debit-note/add", newDebitNote,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DEBIT_NOTE, payload: response.data });
        } else {
          dispatch({
            type: DEBIT_NOTE_REQUEST_FAILURE,
            error: "Debit Note create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDebitNote = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
      const { auth } = getState();
      return axios.put("/debit-note/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: DEBIT_NOTE_REQUEST_FAILURE,
            error: "Debit Note update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDebitNote = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/debit-note/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DEBIT_NOTE, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Credit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount', 'Item_Id'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { inventory: { debitNote: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getDebitNotesWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};


export const sendMailDebitNote = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('debitNoteId', mailData.debitNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `debit_node_${mailData.debitNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/debit-note/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: DEBIT_NOTE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: DEBIT_NOTE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: DEBIT_NOTE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappDebitNote = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('debitNoteId', whatsappData.debitNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `debit_node_${whatsappData.debitNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/debit-note/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: DEBIT_NOTE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: DEBIT_NOTE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: DEBIT_NOTE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};